import { axiosInstance } from '@/utils/api'
import { IMarumiyaProduct } from '@/utils/types/model/marumiyaProduct'

interface IMarumiyaProductListResponse {
  totalRecords: number
  products: IMarumiyaProduct[]
}

export interface IMarumiyaProductParams {
  page: number
  limit: number
  itemCode?: string
  sortBy?: string
  sortType?: string
  [key: string]: unknown
}

export async function getMarumiyaProducts(params: IMarumiyaProductParams): Promise<IMarumiyaProductListResponse> {
  const response = await axiosInstance.get('/products', { params: { ...params } })
  return response.data
}

export async function exportMarumiyaProducts(data: { sortBy?: string; sortType?: string }) {
  const response = await axiosInstance.post('/products/export', data)
  return response.data
}
